import isFinite from 'lodash/isFinite';
import type { DownloadProgressDto } from '@mimir/common/dto/transferRequestDtos';
import type { ProgressEntry } from '@mimir/primitive/structuredLogger';
import type { CancelToken } from 'axios';

export type ProgressHandler = (downloadStats: DownloadProgressDto) => Promise<void>;
export type DownloadAndMuxTask = (onProgress: ProgressHandler, ct: CancelToken) => Promise<void>;

export function downloadProgressDtoFromProgressEntry(
  progress: ProgressEntry,
  startTime: number,
): DownloadProgressDto | null {
  if (progress.position === undefined || progress.length === undefined || !isFinite(progress.position) || !isFinite(progress.length)) {
    return null;
  }
  const factor = progress.position / progress.length;
  const elapsedTime = Date.now() - startTime;
  let estimatedRemainingTime : number | null = null;
  if (isFinite(factor) && (factor > 0.0)) {
    estimatedRemainingTime = elapsedTime * ((1.0 / factor) - 1.0);
  }
  return {
    elapsedTime,
    estimatedRemainingTime,
    speed: null,
    totalSize: progress.length,
    transferred: progress.position,
    progressUnit: progress.unit === 'bytes' ? 'byte' : undefined,
  };
}

